export default __webpack_public_path__ + "static/media/discount.9232c25e.svg";